// This filter was generated by AI for filtering API consumers by partner username.
import {ApiConsumer} from '@eitje/api'
import _ from 'lodash'

export const useApiConsumerPartnerUsernameFilter = () => {
	const items = _.sortBy(ApiConsumer.useAll(), 'partner_username')

	const filterFn = (apiConsumer, apiConsumerIds) => {
		return apiConsumerIds.includes(apiConsumer.id)
	}

	return {items, filterFn, labelField: 'partner_username'}
}
